import {
  BulkUpdateStatusHeadcountRequestDocument,
  HeadcountCountPendingRequestsDocument,
  HeadcountRequestsDocument,
  HeadcountSummariesDocument,
  PlanningValueObjectsRequestStatusEnum,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type StatusUpdate = {
  id: string
  status: PlanningValueObjectsRequestStatusEnum
}

const useHeadcountStatusMutations = () => {
  const [bulkUpdateStatusMutation] = useMutation(BulkUpdateStatusHeadcountRequestDocument, {
    extractorFn: (data) => data.planningMutations.bulkUpdateStatusPlanningRequest,
  })

  const showError = () => {
    app.setFlash({
      type: 'wrong',
      message: i18n.t('common.save_error'),
      time: 2000,
    })
  }

  const bulkUpdateStatus = async (updates: StatusUpdate[]) => {
    if (updates.length === 0) return { success: true }

    const result = await bulkUpdateStatusMutation({
      variables: { updates },
      refetchQueries: [
        HeadcountRequestsDocument,
        HeadcountSummariesDocument,
        HeadcountCountPendingRequestsDocument,
      ],
    })

    const handled = handleResult(result, () => undefined)
    if (!handled.success) {
      showError()
    }

    return { success: handled.success }
  }

  return { bulkUpdateStatus }
}

export default useHeadcountStatusMutations
